<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <div *ngIf="title" class="modal--title">{{ title }}</div>
    <div *ngIf="title" class="modal--subtitle">{{ message }}</div>
  </section>

  <section class="modal-actions-container">
    <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">{{ cancelCTA }}</button>
    <button alt="Confirm" class="btn btn-lg {{ confirmClass }}" (click)="confirm()">
      {{ confirmCTA }}
    </button>
  </section>
</div>
